/** THIS IS GENERATED FILE. DO NOT EDIT! */
import { ReactComponent as AccountSettings } from './icons/account-settings.svg'
import { ReactComponent as Arrow } from './icons/arrow.svg'
import { ReactComponent as Bars } from './icons/bars.svg'
import { ReactComponent as Bnb } from './icons/bnb.svg'
import { ReactComponent as Bounuses } from './icons/bounuses.svg'
import { ReactComponent as Btc } from './icons/btc.svg'
import { ReactComponent as Busd } from './icons/busd.svg'
import { ReactComponent as Calendar } from './icons/calendar.svg'
import { ReactComponent as Cards } from './icons/cards.svg'
import { ReactComponent as CaretDown } from './icons/Caret_Down.svg'
import { ReactComponent as Cashback } from './icons/cashback.svg'
import { ReactComponent as Chevron } from './icons/chevron.svg'
import { ReactComponent as Clear } from './icons/clear.svg'
import { ReactComponent as Close } from './icons/close.svg'
import { ReactComponent as Copy } from './icons/copy.svg'
import { ReactComponent as CrashGames } from './icons/crash-games.svg'
import { ReactComponent as Crypto } from './icons/crypto.svg'
import { ReactComponent as CryptoDefault } from './icons/cryptoDefault.svg'
import { ReactComponent as Cup } from './icons/cup.svg'
import { ReactComponent as Deposit } from './icons/deposit.svg'
import { ReactComponent as Doge } from './icons/doge.svg'
import { ReactComponent as Dollar } from './icons/dollar.svg'
import { ReactComponent as Dz } from './icons/dz.svg'
import { ReactComponent as Edit } from './icons/edit.svg'
import { ReactComponent as Eg } from './icons/eg.svg'
import { ReactComponent as Eth } from './icons/eth.svg'
import { ReactComponent as EyeOff } from './icons/Eye-off.svg'
import { ReactComponent as EyeOn } from './icons/Eye-on.svg'
import { ReactComponent as File } from './icons/file.svg'
import { ReactComponent as Filter } from './icons/filter.svg'
import { ReactComponent as Friends } from './icons/friends.svg'
import { ReactComponent as Gift } from './icons/gift.svg'
import { ReactComponent as InfoCircle } from './icons/info-circle.svg'
import { ReactComponent as Inyan } from './icons/inyan.svg'
import { ReactComponent as Keno } from './icons/keno.svg'
import { ReactComponent as Lock } from './icons/lock.svg'
import { ReactComponent as LogoGray } from './icons/logo-gray.svg'
import { ReactComponent as Logout } from './icons/logout.svg'
import { ReactComponent as Lotto } from './icons/lotto.svg'
import { ReactComponent as Loudspeaker } from './icons/loudspeaker.svg'
import { ReactComponent as Ltc } from './icons/ltc.svg'
import { ReactComponent as Ma } from './icons/ma.svg'
import { ReactComponent as MakeDeposit } from './icons/makeDeposit.svg'
import { ReactComponent as Monitor } from './icons/monitor.svg'
import { ReactComponent as Pagstar } from './icons/pagstar.svg'
import { ReactComponent as Password } from './icons/Password.svg'
import { ReactComponent as PaymentQueries } from './icons/payment-queries.svg'
import { ReactComponent as Peaks } from './icons/peaks.svg'
import { ReactComponent as Pix } from './icons/pix.svg'
import { ReactComponent as Profile } from './icons/profile.svg'
import { ReactComponent as Promotions } from './icons/promotions.svg'
import { ReactComponent as Question } from './icons/question.svg'
import { ReactComponent as Reload } from './icons/reload.svg'
import { ReactComponent as Search } from './icons/search.svg'
import { ReactComponent as Security } from './icons/security.svg'
import { ReactComponent as Slots } from './icons/slots.svg'
import { ReactComponent as Spin2Win } from './icons/Spin2Win.svg'
import { ReactComponent as SpinnerFilled } from './icons/spinner-filled.svg'
import { ReactComponent as Sports } from './icons/sports.svg'
import { ReactComponent as Star } from './icons/star.svg'
import { ReactComponent as Telegram } from './icons/telegram.svg'
import { ReactComponent as Telephone } from './icons/telephone.svg'
import { ReactComponent as Transaction } from './icons/transaction.svg'
import { ReactComponent as Transactions } from './icons/transactions.svg'
import { ReactComponent as Trx } from './icons/trx.svg'
import { ReactComponent as Usdtbsc } from './icons/usdtbsc.svg'
import { ReactComponent as Usdterc } from './icons/usdterc.svg'
import { ReactComponent as Usdtmatic } from './icons/usdtmatic.svg'
import { ReactComponent as Usdtsol } from './icons/usdtsol.svg'
import { ReactComponent as Usdttrc } from './icons/usdttrc.svg'
import { ReactComponent as User } from './icons/user.svg'
import { ReactComponent as UserCircle } from './icons/user-circle.svg'
import { ReactComponent as Wallet } from './icons/wallet.svg'
import { ReactComponent as Whatsapp } from './icons/whatsapp.svg'
import { ReactComponent as Withdraw } from './icons/withdraw.svg'

export type IconTypes =
  | 'account-settings'
  | 'arrow'
  | 'bars'
  | 'bnb'
  | 'bounuses'
  | 'btc'
  | 'busd'
  | 'calendar'
  | 'cards'
  | 'Caret_Down'
  | 'cashback'
  | 'chevron'
  | 'clear'
  | 'close'
  | 'copy'
  | 'crash-games'
  | 'crypto'
  | 'cryptoDefault'
  | 'cup'
  | 'deposit'
  | 'doge'
  | 'dollar'
  | 'dz'
  | 'edit'
  | 'eg'
  | 'eth'
  | 'Eye-off'
  | 'Eye-on'
  | 'file'
  | 'filter'
  | 'friends'
  | 'gift'
  | 'info-circle'
  | 'inyan'
  | 'keno'
  | 'lock'
  | 'logo-gray'
  | 'logout'
  | 'lotto'
  | 'loudspeaker'
  | 'ltc'
  | 'ma'
  | 'makeDeposit'
  | 'monitor'
  | 'pagstar'
  | 'Password'
  | 'payment-queries'
  | 'peaks'
  | 'pix'
  | 'profile'
  | 'promotions'
  | 'question'
  | 'reload'
  | 'search'
  | 'security'
  | 'slots'
  | 'Spin2Win'
  | 'spinner-filled'
  | 'sports'
  | 'star'
  | 'telegram'
  | 'telephone'
  | 'transaction'
  | 'transactions'
  | 'trx'
  | 'usdtbsc'
  | 'usdterc'
  | 'usdtmatic'
  | 'usdtsol'
  | 'usdttrc'
  | 'user-circle'
  | 'user'
  | 'wallet'
  | 'whatsapp'
  | 'withdraw'
export const ICON_TYPE_NAMES = [
  'account-settings',
  'arrow',
  'bars',
  'bnb',
  'bounuses',
  'btc',
  'busd',
  'calendar',
  'cards',
  'Caret_Down',
  'cashback',
  'chevron',
  'clear',
  'close',
  'copy',
  'crash-games',
  'crypto',
  'cryptoDefault',
  'cup',
  'deposit',
  'doge',
  'dollar',
  'dz',
  'edit',
  'eg',
  'eth',
  'Eye-off',
  'Eye-on',
  'file',
  'filter',
  'friends',
  'gift',
  'info-circle',
  'inyan',
  'keno',
  'lock',
  'logo-gray',
  'logo',
  'logout',
  'lotto',
  'loudspeaker',
  'ltc',
  'ma',
  'makeDeposit',
  'monitor',
  'pagstar',
  'Password',
  'payment-queries',
  'peaks',
  'pix',
  'profile',
  'promotions',
  'question',
  'reload',
  'search',
  'security',
  'slots',
  'Spin2Win',
  'spinner-filled',
  'sports',
  'star',
  'telegram',
  'telephone',
  'transaction',
  'transactions',
  'trx',
  'usdtbsc',
  'usdterc',
  'usdtmatic',
  'usdtsol',
  'usdttrc',
  'user-circle',
  'user',
  'wallet',
  'whatsapp',
  'withdraw',
]

export const ICONS = {
  'account-settings': AccountSettings,
  arrow: Arrow,
  bars: Bars,
  bnb: Bnb,
  bounuses: Bounuses,
  btc: Btc,
  busd: Busd,
  calendar: Calendar,
  cards: Cards,
  Caret_Down: CaretDown,
  cashback: Cashback,
  chevron: Chevron,
  clear: Clear,
  close: Close,
  copy: Copy,
  'crash-games': CrashGames,
  crypto: Crypto,
  cryptoDefault: CryptoDefault,
  cup: Cup,
  deposit: Deposit,
  doge: Doge,
  dollar: Dollar,
  dz: Dz,
  edit: Edit,
  eg: Eg,
  eth: Eth,
  'Eye-off': EyeOff,
  'Eye-on': EyeOn,
  file: File,
  filter: Filter,
  friends: Friends,
  gift: Gift,
  'info-circle': InfoCircle,
  inyan: Inyan,
  keno: Keno,
  lock: Lock,
  'logo-gray': LogoGray,
  logout: Logout,
  lotto: Lotto,
  loudspeaker: Loudspeaker,
  ltc: Ltc,
  ma: Ma,
  makeDeposit: MakeDeposit,
  monitor: Monitor,
  pagstar: Pagstar,
  Password,
  'payment-queries': PaymentQueries,
  peaks: Peaks,
  pix: Pix,
  profile: Profile,
  promotions: Promotions,
  question: Question,
  reload: Reload,
  search: Search,
  security: Security,
  slots: Slots,
  Spin2Win,
  'spinner-filled': SpinnerFilled,
  sports: Sports,
  star: Star,
  telegram: Telegram,
  telephone: Telephone,
  transaction: Transaction,
  transactions: Transactions,
  trx: Trx,
  usdtbsc: Usdtbsc,
  usdterc: Usdterc,
  usdtmatic: Usdtmatic,
  usdtsol: Usdtsol,
  usdttrc: Usdttrc,
  'user-circle': UserCircle,
  user: User,
  wallet: Wallet,
  whatsapp: Whatsapp,
  withdraw: Withdraw,
}
